import { render, staticRenderFns } from "./cModalViewImagen.vue?vue&type=template&id=4b92056e"
import script from "./cModalViewImagen.vue?vue&type=script&lang=js"
export * from "./cModalViewImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports